import Layout from '@components/layout/Main'
import Background from '@components/image/Background'
import TrailerSearchpageForm from '@components/search/forms/TrailerSearchpageForm'

import ViewContextProvider, { VIEWS } from '@context/ViewContext'
import BreadcrumbBar from '@components/breadcrumbs/BreadcrumbBar'
import Sort from '@components/select/Sort'
import State from '@components/select/State'
import View from '@components/select/View'

import AdList from '@components/lists/AdList'
import FAQ from '@components/shared/FAQ'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'

import SeoHeadings from '@pages/search/SearchSeoHeadings'
import Seo from 'src/seo/components/Seo'
import JsonLdSearch from 'src/seo/jsonld/JsonLdSearch'

import dbConnect from 'db/dbConnect'
import listTrailerAds from 'db/repo/listAds/listAdsTrailer'
import sessionCookies from '@utils/sessionCookies'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import useSeoArticle from 'src/seo/components/articles/useSeoArticle'
import locationLdSchema from 'src/seo/jsonld/server/locationLdSchema'
import unslugify from '@utils/links/searchUnslugifyNumericParams'
import substituteSearchQuery from '@pages/search/functions/substituteSearchQuery'
import makeSearchTrailerLinks from '@components/frontpage/functions/makeSearchTrailerLinks'
import trailerFallbackSeo from 'src/seo/server/fallbackSeoTrailer'

const DEFAULT_HEADINGS = {
    h1: 'Przyczepy',
    h2: 'Szukasz przyczepy? Sprawdź oferty sprzedaży.',
}

export default function TrailerSearchpage ({
    cubeLinks, query, offers, pagination,
    seo, locationObjectLd }) {

    const [seoArticleExcerpt, seoArticleBody] = useSeoArticle(seo.articleFile)

    return (
        <Layout>
            <Seo seo={seo} offers={offers} />
            <JsonLdSearch
                baseUrl="/przyczepy"
                buy={false}
                category="Przyczepy"
                locationObjectLd={locationObjectLd}
                offers={offers} />

            <Background
                collapseWhen="form_expands"
                height={320}
                src="/backgrounds/przyczepy-i-naczepy-na-sprzedaz.webp"
                alt="Przyczepy, naczepy na sprzedaż"
                z={7}>

                <TrailerSearchpageForm query={query} />

            </Background>

            <ViewContextProvider defaultView={VIEWS.LIST}>
                <SeoHeadings seo={seo} defaultValues={DEFAULT_HEADINGS} />
                {seoArticleExcerpt}

                <BreadcrumbBar>
                    <State />
                    <Sort />
                    <View />
                </BreadcrumbBar>

                <AdList {...{
                    below: seoArticleBody,
                    offers,
                    pagination, }} />
            </ViewContextProvider>

            <FrontpageLinks sections={cubeLinks} />

            <FAQ qa={seo.faqFile} page="trailer_searchpage" />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = unslugify(context.query)
    const cookies = sessionCookies(context)
    const { ads, pagination } = await listTrailerAds(query, { cookies })
    return {
        props: {
            cubeLinks: await makeSearchTrailerLinks(query, '/przyczepy'),
            query,
            offers: ads,
            pagination,
            seo: await useUrlSeo({
                baseUrl: '/przyczepy',
                defaultSeo: {
                    ...DEFAULT_HEADINGS,
                    title: DEFAULT_HEADINGS.h1,
                    description: DEFAULT_HEADINGS.h2,
                },
                fallbackFunction: trailerFallbackSeo,
                resolvedUrl: context.resolvedUrl,
                query,
                substituteQuery: substituteSearchQuery(query),
            }),
            locationObjectLd: locationLdSchema(query.lokalizacja),
        }
    }
}